import type React from 'react'

import { Banner } from 'slab'
import { conditionallyLocalizeDate, supportEmail } from 'utils'
import { type MembersCoveredParticipant, MembersCoveredParticipantQualifyingLifeEventStatus } from 'utils/web_api.schemas'

const QLEBanner: React.FC<{
  dependent: MembersCoveredParticipant
}> = ({ dependent }) => {
  const possessiveDependent = dependent.given_name.endsWith('s') ? `${dependent.given_name}'` : `${dependent.given_name}'s`
  const dependentStartDate = dependent.coverage_start_date ? new Date(dependent.coverage_start_date) : undefined

  switch (dependent.qualifying_life_event_status) {
    case MembersCoveredParticipantQualifyingLifeEventStatus.complete:
      return null
    case MembersCoveredParticipantQualifyingLifeEventStatus.in_progress:
      return (
        <Banner
          type='info'
          title={`${possessiveDependent} enrollment is underway`}
        >
          <p>Everything is on track for coverage to start{dependentStartDate ? ` ${conditionallyLocalizeDate(dependentStartDate)}` : ''}. No action needed right now.</p>
        </Banner>
      )
    case MembersCoveredParticipantQualifyingLifeEventStatus.awaiting_confirmation:
      return (
        <Banner
          type='warning'
          title={`${possessiveDependent} enrollment needs attention`}
        >
          <p>Contact {supportEmail} to ensure {possessiveDependent} coverage starts{dependentStartDate ? ` ${conditionallyLocalizeDate(dependentStartDate)}` : ''}.</p>
        </Banner>
      )
    default:
      return null
  }
}

export default QLEBanner
